function LayoutEntrance({ children }) {
  return <div className="mx-auto flex w-5/6 flex-col md:w-1/2">{children}</div>
}

export default LayoutEntrance
